/** Matches backend CustomerPartyLinkMode. */
export type CustomerPartyLinkMode = 0 | 1 | 2;

/** B2C (0) maps to Individual (0); other customer types map to Organization (1). */
export function mapCustomerTypeToPartyKind(customerType: number): number {
  return customerType === 0 ? 0 : 1;
}
